import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "h-4 w-4 animate-spin rounded-full border-2 border-[inherit] border-b-transparent"
}

import { computed, PropType, ref } from "vue";

type ButtonType = "filled" | "outlined";

const baseButtonStyle =
  "text-xs font-bold uppercase tracking-wider py-2 px-3 rounded-full inline-flex items-center justify-center relative cursor-pointer w-min-32";


export default /*#__PURE__*/_defineComponent({
  __name: 'customButton',
  props: {
  type: { type: String, default: "button" },
  disabled: { type: Boolean, default: false },
  variant: { type: String as PropType<ButtonType> },
  size: { type: String, default: "normal" },
},
  setup(__props) {

const props = __props;

const loading = ref(false);

const handleClick = () => {
  loading.value = true;
};

const colorVariants = computed(() => {
  switch (props.variant) {
    case "filled":
      return "text-white bg-primary hover:bg-opacity-80";
    case "outlined":
      return "border-2 !border-primary text-primary hover:shadow-l";
    default:
      return baseButtonStyle;
  }
});

//TODO ITT TARTOTTAM A LOADING HOZZÁADÁSÁNÁL
const loadingStyle = computed(() => {
  if (loading.value && props.variant === "filled") {
    return "border-white absolute inline-flex items-center";
  }
  if (loading.value && props.variant === "outlined") {
    return "border-primary absolute inline-flex items-center";
  }
  return "border-white absolute inline-flex items-center";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(props.type), {
    disabled: props.disabled,
    variant: props.variant,
    size: props.size,
    class: _normalizeClass([baseButtonStyle, colorVariants.value, loadingStyle.value]),
    onClick: handleClick
  }, {
    default: _withCtx(() => [
      (!loading.value)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (_openBlock(), _createElementBlock("div", _hoisted_1))
    ]),
    _: 3
  }, 8, ["disabled", "variant", "size", "class"]))
}
}

})